/** Возвращает размеры панели с кнопками создания разных типов упражнений */
export function getDrawerWidth() {
	return document.documentElement.clientWidth < 500 ? '100%' : 500
}
